<div class="new_package_container">
    <div class="flex justify-between align-center border-bottom" style="padding: 32px;">
        <div class="fc_DEDEDE fz_21">New Building Type</div>
        <img src="./assets/images/black/close.png" class="close_image" (click)="close()">
    </div>
    <div style="margin-top: 32px;">
        <app-basic-info [isPackage]="true" [landProjectId]="data.projectId" (closeDialogEvent)="closeDialog($event)">
        </app-basic-info>
    </div>

</div>